<template>
  <div>
    <h1 class="header-style">
      Site Check-In
    </h1>
    <br>
    <p class="subheader-style">
      How do you want to check-in ?
    </p>
    <v-card-actions>
      <v-btn
        color="#37474F"
        dark
        class="check-in-style"
        @click="toCheckInProcess('qr-code')"
      >
        <v-icon
          left
          size="20"
        >
          mdi-qrcode-scan
        </v-icon>
        <span class="checkin-btn-name">QR Code</span>
      </v-btn>
      <v-spacer />
      <v-btn
        color="#FF3700"
        class="check-in-style"
        @click="toCheckInProcess('manual')"
      >
        <v-icon
          left
          size="20"
        >
          mdi-account-arrow-right-outline
        </v-icon>
        <span class="checkin-btn-name">Manual</span>
      </v-btn>
    </v-card-actions>
    <center-spinner :loading="loading" />
    <select-organization
      v-if="showOrganizationsList"
      @closed="showOrganizationsList = false"
      @organization-selected="toCheckInTypes"
    />
    <check-in-types
      v-if="showCheckInTypes"
      @closed="showCheckInTypes = false"
      @checkin-type-selected="continueCheckInProcess"
    />
    <qr-code-scanner
      v-if="showQrCodeScanner"
      @closed="showQrCodeScanner = false"
      @qr-code-scanned="toSelectedCheckInProcessByQRScan"
    />
    <select-project
      v-if="showOrganizationProjects"
      @closed="showOrganizationProjects = false"
      @project-selected="toProjectGatesList"
    />
    <select-project-gate
      v-if="showProjectGates"
      @closed="showProjectGates = false"
      @project-gate-selected="toSelectedCheckInProcessByManual"
    />
  </div>
</template>

<script>
import QrCodeScanner from '../../process/QrCodeScanner.vue';
import spinner from '../../components/SpinnerCentre.vue';
import Constants from 'src/constants';
import SelectOrganization from 'src/views/dashboard/Components/dialogComponents/SelectOrganization';
import CheckInTypes from 'src/views/dashboard/Components/CheckInTypes';
import SelectProject from 'src/views/dashboard/Components/dialogComponents/SelectProject';
import SelectProjectGate from 'src/views/dashboard/Components/dialogComponents/SelectProjectGate';
export default {
  name: 'CheckInCheckOutPage',
  components: {
    'qr-code-scanner': QrCodeScanner,
    'center-spinner': spinner,
    'select-organization': SelectOrganization,
    'check-in-types': CheckInTypes,
    'select-project': SelectProject,
    'select-project-gate': SelectProjectGate,
  },
  data: () => ({
    loading: false,
    selectedCheckInType: null,
    userDetails: {},
    showQrCodeScanner: false,
    showOrganizationsList: false,
    checkInMethodType: null,
    showOrganizationProjects: false,
    showProjectGates: false,
    showCheckInTypes: false,
  }),
  computed: {
    userOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    selectedOrgProjectGate () {
      return this.$store.getters['projects/getSelectedOrgProjectGate'];
    },
    activeCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    isActiveCheckInDetailsFetched () {
      if (Object.keys(this.activeCheckInDetails).length > 0) {
        return true;
      }
      return false;
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
  },
  async mounted () {
    await this.loadOnMount();
    this.getUserOrganizations();
    this.checkQrScanTime();
  },
  methods: {
    checkQrScanTime () {
      const scannedTime = localStorage.getItem('scannedTime');
      if (scannedTime === null) {
        return;
      }
      const currentTime = new Date().getTime();
      if (currentTime - scannedTime >= 300000) {
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
      }
    },
    loadOnMount () {
      if (this.isActiveCheckInDetailsFetched === false) {
        return;
      }
      this.$router.push({ name: 'HomePage' });
    },
    async getUserOrganizations () {
      this.loading = true;
      await this.$store
        .dispatch('organization/fetchUserOrganizations', {
          params: {
            requestStatus: 'accepted',
          },
        })
        .catch(() => {
          this.loading = false;
        });
      this.loading = false;
    },
    toCheckInProcess (type) {
      this.loading = true;
      this.checkInMethodType = type;
      if (this.userOrganizations.length > 0) {
        this.loading = true;
        this.$store.dispatch('organization/selectedOrganization', this.selectedOrganization);
        this.loading = false;
        this.toCheckInTypes();
      } else {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'You are not under any organizations.',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        this.loading = false;
        this.$router.push({ name: 'Organizations' });
      }
    },
    toCheckInTypes () {
      this.showOrganizationsList = false;
      this.showCheckInTypes = true;
    },
    continueCheckInProcess (type) {
      this.showOrganizationsList = false;
      this.showCheckInTypes = false;
      this.selectedCheckInType = type;
      if (this.checkInMethodType === 'manual') {
        this.$store.dispatch('swiftuser/storeCheckInMethodType', {
          type: 'manual-checkin',
        });
        this.loading = false;
        this.showOrganizationProjects = true;
      } else {
        this.$store.dispatch('swiftuser/storeCheckInMethodType', {
          type: 'qr-code-checkin',
        });
        this.loading = false;
        this.openQrCodeScanner();
      }
    },
    toProjectGatesList () {
      this.showOrganizationsList = false;
      this.showCheckInTypes = false;
      this.showOrganizationProjects = false;
      this.showProjectGates = true;
    },
    toSelectedCheckInProcessByManual () {
      this.loading = true;
      this.showOrganizationsList = false;
      this.showCheckInTypes = false;
      this.showOrganizationProjects = false;
      this.showProjectGates = false;
      const type = this.selectedCheckInType;
      const siteId = this.selectedOrgProjectGate.id;
      this.$router.push(`check-in/${siteId}/${type}`);
    },
    openQrCodeScanner () {
      this.loading = true;
      this.checkQrScanTime();
      const siteId = localStorage.getItem('siteId');
      if (siteId !== null) {
        this.toSelectedCheckInProcessByQRScan(siteId);
        this.loading = false;
        return;
      }
      setTimeout(() => {
        this.showQrCodeScanner = true;
        this.loading = false;
      }, 1000);
    },
    toSelectedCheckInProcessByQRScan (id) {
      if (id.length === 0 || id === 'undefined') {
      this.$store.dispatch('alert/onAlert', {
        message: 'Unauthorized QR-Code',
        type: Constants.ALERT_TYPE_ERROR,
      }, { root: true });
      localStorage.removeItem('siteId');
      return;
      }
      this.loading = true;
      this.showOrganizationsList = false;
      this.showCheckInTypes = false;
      this.showQrCodeScanner = false;
      const type = this.selectedCheckInType;
      const siteId = id;
      this.$router.push(`check-in/${siteId}/${type}`);
    },
  },
};
</script>
